module.exports = __webpack_public_path__ + "static/media/senlin.48bdbc2e.mp4";